import Vue from 'vue';

// indexDB reference: https://developers.google.com/web/ilt/pwa/lab-indexeddb
import idb from 'idb';

// all vuex modules ///////////////////////////////////
import Vuex from 'vuex';

import auth from './modules/auth';
import nav from './modules/nav';
import orderMenu from './modules/orderMenu';
import orderTab from './modules/orderTab';
import modal from './modules/modal';
import pwa from './modules/pwa';
import merchant from './modules/merchant';
import keypad from './modules/keypad';
import orders from './modules/orders';
import cards from './modules/cards';
import inAppMsg from './modules/inAppMsg';
import transactions from './modules/transactions';

import router from '../router/router';

Vue.use( Vuex );
////////////////////////////////////////////////////////

export const store = new Vuex.Store({

    state: {

        appVersion        : 1.00,
        showBackDrop      : false,
        isLoading         : false,
        loadingStatus     : null,
        uiSuccess         : false,
        triggerTransition : false,
        imageUrl          : process.env.VUE_APP_IMAGE_URL,
        unitedStates      : {

            NA : 'n/a',
            AL : 'Alabama',
            AK : 'Alaska',
            AZ : 'Arizona',
            AR : 'Arkansas',
            CA : 'California',
            CO : 'Colorado',
            CT : 'Connecticut',
            DE : 'Delaware',
            DC : 'District Of Columbia',
            FL : 'Florida',
            GA : 'Georgia',
            HI : 'Hawaii',
            ID : 'Idaho',
            IL : 'Illinois',
            IN : 'Indiana',
            IA : 'Iowa',
            KS : 'Kansas',
            KY : 'Kentucky',
            LA : 'Louisiana',
            ME : 'Maine',
            MD : 'Maryland',
            MA : 'Massachusetts',
            MI : 'Michigan',
            MN : 'Minnesota',
            MS : 'Mississippi',
            MO : 'Missouri',
            MT : 'Montana',
            NE : 'Nebraska',
            NV : 'Nevada',
            NH : 'New Hampshire',
            NJ : 'New Jersey',
            NM : 'New Mexico',
            NY : 'New York',
            NC : 'North Carolina',
            ND : 'North Dakota',
            OH : 'Ohio',
            OK : 'Oklahoma',
            OR : 'Oregon',
            PA : 'Pennsylvania',
            RI : 'Rhode Island',
            SC : 'South Carolina',
            SD : 'South Dakota',
            TN : 'Tennessee',
            TX : 'Texas',
            UT : 'Utah',
            VT : 'Vermont',
            VA : 'Virginia',
            WA : 'Washington',
            WV : 'West Virginia',
            WI : 'Wisconsin',
            WY : 'Wyoming',
        },
        currentRoute      : {

            name: ''
        },
        previousRoute     : {

            name: ''
        },
        idbVersion         : 9,
        environment        : process.env.VUE_APP_ENVIRONMENT
    },
    mutations: {

        backDropClicked : state => state.showBackDrop = !state.showBackDrop,
        toggleBackdrop  : state => state.showBackDrop = !state.showBackDrop,
        triggerTransition : state => state.triggerTransition = !state.triggerTransition,
        loadingStatus( state, value ){

            state.isLoading = false;
            state.loadingStatus = value;
        },
        updateNavigation( state, data ){

            if( data.from.name != null ) state.previousRoute = data.from;
            state.currentRoute = data.to;
        },
        toggleUiSuccess : state => state.uiSuccess = !state.uiSuccess
    },
    actions: {

        backDropClicked( { commit } ){

            commit( 'backDropClicked' );
            commit( 'nav/backDropClicked' );
            commit( 'modal/backDropClicked' );
        },
        clearIndexDb( { commit, state, dispatch } ){

            let dbPromise = idb.open( 'quickOrdersDB', state.idbVersion );
            dbPromise.then( db => {

                let txCategories = db.transaction( 'menuCategories', 'readwrite' );
                    txCategories.objectStore( 'menuCategories' ).clear();

                let txItems = db.transaction( 'menuItems', 'readwrite' );
                    txItems.objectStore( 'menuItems' ).clear();

                let txModifierGroups = db.transaction( 'menuModifierGroups', 'readwrite' );
                    txModifierGroups.objectStore( 'menuModifierGroups' ).clear();

                let txModifierItemGroups = db.transaction( 'menuItemModifierGroups', 'readwrite' );
                    txModifierItemGroups.objectStore( 'menuItemModifierGroups' ).clear();

                let txPastTransactions = db.transaction( 'pastTransactions', 'readwrite' );
                    txPastTransactions.objectStore( 'pastTransactions' ).clear();

                let txInAppMsgs = db.transaction( 'inAppMsgs', 'readwrite' );
                    txInAppMsgs.objectStore( 'inAppMsgs' ).clear();

                let txCardWallet = db.transaction( 'cardWallet', 'readwrite' );
                    txCardWallet.objectStore( 'cardWallet' ).clear();

                let txPastOrders = db.transaction( 'pastOrders', 'readwrite' );
                    txPastOrders.objectStore( 'pastOrders' ).clear();
            });
            dispatch( 'transactions/clearState', null, { root: true } );
            dispatch( 'inAppMsg/clearState', null, { root: true } );
            dispatch( 'cards/clearState', null, { root: true } );
            dispatch( 'orders/clearState', null, { root: true } );

            dispatch( 'orderMenu/needsMenu', null, { root: true } );
            dispatch( 'orderTab/clearTab', null, { root: true } );
        },
        updateNavigation( { commit }, data ){

            commit( 'updateNavigation', data );
        },
        triggerTransition( { commit } ){

            commit( 'triggerTransition' );
        },
        updateLoadingStatus( { commit }, value ){

            commit( 'loadingStatus', value );
            setTimeout( function(){

                commit( 'loadingStatus', null );
            }, 3000);
        },
        uiSuccess( { commit } ){

            commit( 'toggleUiSuccess' );
            setTimeout( () => {

                commit( 'toggleUiSuccess' );
            }, 1000 );
        }
    },
    getters: {

        showBackDrop      : state => state.showBackDrop,
        isLoading         : state => state.isLoading,
        imageUrl          : state => state.imageUrl,
        unitedStates      : state => state.unitedStates,
        currentRoute      : state => state.currentRoute,
        previousRoute     : state => state.previousRoute,
        triggerTransition : state => state.triggerTransition,
        environment       : state => state.environment,
        idbVersion        : state => state.idbVersion,
        uiSuccess         : state => state.uiSuccess,
        loadingStatus     : state => state.loadingStatus,
        currentDevice(){

            let userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if ( /windows phone/i.test( userAgent ) ) {

                return "Windows Phone";
            }

            if ( /android/i.test( userAgent ) ) {

                return "Android";
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if ( /iPad|iPhone|iPod/.test( userAgent ) && !window.MSStream ) {

                return "iOS";
            }

            return "unknown";
        },
        publicKey( state, rootGetters ){

            if( rootGetters[ 'auth/isAuth' ] ){

                var base64Url = state.auth.isAuth.split( '.' )[ 1 ];
                var base64    = base64Url.replace( '-', '+' ).replace( '_', '/' );
                const data    = JSON.parse( window.atob( base64 ) );

                return data.pubKey;
            } else return null;
        }
    },
    modules: {

        auth,
        nav,
        orderMenu,
        orderTab,
        modal,
        pwa,
        merchant,
        keypad,
        orders,
        cards,
        inAppMsg,
        transactions
    }
});